import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import CaseStudyGallery from './CaseStudyGallery'
import CaseStudyQuotes from './CaseStudyQuotes'
import CaseStudyContentBlock from './CaseStudyContentBlock'
import CaseStudyBasicInfo from './CaseStudyBasicInfo'
import CaseStudyProductsSlider from './CaseStudyProductsSlider'
import CaseStudyRelatedStudies from './CaseStudyRelatedStudies'
import Loading from '../../Loading/Loading'
import '../styles/CaseStudy.scss'

const CaseStudy = (props) => {

    const [CaseStudy, fetchCaseStudy] = useState(null)
    const [LoadingState, setLoading] = useState(true)

    const getData = () => {
        fetch(props.apiUrl, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then((res) => res.json())
            .then((res) => {
                console.log(res.Data)
                fetchCaseStudy(res.Data)
                setLoading(false)
            })
    }

    useEffect(() => {
        console.log("Getting data")
        getData()
    }, [])

    const formatUrl = (url) => {
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = `http://${url}`
        }

        return url;
    }

    return LoadingState ? (
        <Loading loadingtext="" />
    ) : (
        <div id="converge-casestudy">
            <div className="onepcssgrid-1300 onepcssblockgrid">
                <div className="onerow">
                    <div className="col12 last">
                        <div id="cs-intro">
                            <h2>{CaseStudy.Title}</h2>
                        </div>
                        {CaseStudy.GalleryApiUrl}
                        <CaseStudyGallery apiUrl={CaseStudy.CaseStudyGalleryApiUrl} />

                        <div className={`cs-grid-item basic-info ${CaseStudy.AssociatedProducts.length > 0 ? '' : 'cs-fullwidth'}`}>
                            <h4>{i18njs["Resource.CaseStudy"]}</h4>
                            <CaseStudyBasicInfo imageurl='/images/industry.png' title={i18njs["Resource.industry"]} body={CaseStudy.OrganisationIndustry} />
                            <CaseStudyBasicInfo imageurl='/images/location.png' title={i18njs["Resource.region"]} body={CaseStudy.Region} />
                            <CaseStudyBasicInfo imageurl='/images/product.png' title={i18njs["Resource.typeofsolution"]} body={CaseStudy.SolutionType} />
                        </div>

                        {CaseStudy.AssociatedProducts.length > 0 &&
                            <div className="cs-grid-item cs-right">
                                <h4>{i18njs["Resource.OptomaProductsUsed"]}</h4>
                                <CaseStudyProductsSlider products={CaseStudy.AssociatedProducts} />
                            </div>}

                        <div className="cs-grid-item cs-fullwidth">
                            <h4>{i18njs["Resource.Client"]}</h4>
                            <div className="content client-info">
                                <div className="content-image client-info">
                                    <img src={CaseStudy.OrgLogoUrl} alt={CaseStudy.OrganisationName} />
                                </div>
                                <div className="content-text client-info">
                                    <h4>{i18njs["Resource.CompanyName"]}</h4>
                                    <p>{CaseStudy.OrganisationName}</p>
                                    {CaseStudy.OrganisationBio != null &&
                                        <div className="bio client-info">
                                            <h4>{i18njs["Resource.Bio"]}</h4>
                                            <p>{CaseStudy.OrganisationBio}</p>
                                        </div>}
                                    {CaseStudy.OrganisationCompanyWeb != null &&
                                        <div className="btn client-info">
                                            <a className="bio client-info btn" href={formatUrl(CaseStudy.OrganisationCompanyWeb)}>
                                                {CaseStudy.OrganisationCompanyWeb.replace("http://", "").replace("https://", "")}
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>

                            {CaseStudy.InstallerCompanyName != null &&
                                <React.Fragment>
                                    <h4>{i18njs["Resource.Installer"]}</h4>
                                    <div className="content installer">
                                        <div className="content-image installer no-image">
                                        </div>
                                        <div className="content-text installer">
                                            <h4>{i18njs["Resource.CompanyName"]}</h4>
                                            <p>{CaseStudy.InstallerCompanyName}</p>
                                            {CaseStudy.InstallerCompanyShort != null &&
                                                <div className="bio installer">
                                                    <h4>{i18njs["Resource.Bio"]}</h4>
                                                    <p>{CaseStudy.InstallerCompanyShort}</p>
                                                </div>
                                            }
                                            {CaseStudy.InstallerCompanyWeb &&
                                                <div className="content-button installer">
                                                    <a href={formatUrl(CaseStudy.InstallerCompanyWeb)} className="btn installer" target="_blank">
                                                        {CaseStudy.InstallerCompanyWeb.replace("http://", "").replace("https://", "")}
                                                    </a>
                                                </div>}
                                        </div>
                                    </div>
                                </React.Fragment>}
                        </div>
                    </div>
                </div>
            </div>

            <div id="cs-hero-quote">
                <div className="main-text">
                    <p>{CaseStudy.HeroQuoteText}</p>
                </div>
                <div className="source">
                    <p className="title">{CaseStudy.HeroQuoteSource}</p>
                </div>
            </div>

            <div className="onepcssgrid-1300 onepcssblockgrid">
                <div className="onerow">
                    <div className="col12 last markdownStyles">

                        <CaseStudyContentBlock title={i18njs["Resource.challenge"]} body={CaseStudy.ContentBlock1} imageurl={CaseStudy.ContentBlock1ImageUrl} />

                        <CaseStudyContentBlock title={i18njs["Resource.solution"]} body={CaseStudy.ContentBlock2} imageurl={CaseStudy.ContentBlock2ImageUrl} />

                        <CaseStudyContentBlock title={i18njs["Resource.results"]} body={CaseStudy.ContentBlock3} imageurl={CaseStudy.ContentBlock3ImageUrl} />

                    </div>
                </div>
            </div>

            {CaseStudy.Equipment.length > 0 &&
                <div id="cs-equipmentlist">
                    <div className="onepcssgrid-1300 onepcssblockgrid">
                        <div className="onerow">
                            <div className="col12 last">
                                <h4 className="casestudies">{i18njs["Resource.equipmentlist"]}</h4>
                                <ul className={CaseStudy.Equipment.length > 1 ? "multi" : " single"}>
                                    {CaseStudy.Equipment.map((e) => (
                                        <li key={e}>
                                            <span>{e}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {CaseStudy.Quotes.length > 0 &&
                <div className="onepcssgrid-1300 onepcssblockgrid">
                    <div className="onerow">
                        <div className="col12 last">
                            <CaseStudyQuotes Quotes={CaseStudy.Quotes} />
                        </div>
                    </div>
                </div>
            }

            {CaseStudy.AssociatedCaseStudies.length > 0 &&
                <div id="cs-association-container">
                    <div className="onepcssgrid-1300 onepcssblockgrid">
                        <div className="onerow">
                            <div className="col12 last">
                                <CaseStudyRelatedStudies RelatedCaseStudies={CaseStudy.AssociatedCaseStudies} />
                            </div>
                        </div>
                    </div>
                </div>
            }

        </div>
    )

}

export default CaseStudy;